export default "__VITE_ASSET__DkO0Vujc__"